<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { useAlertStore } from '@/store'

const alertStore = useAlertStore()
const { alert } = storeToRefs(alertStore)
</script>

<template>
  <div v-if="alert" class="container p-0">
    <div class="alert alert-dismissible fade show" :class="alert.type" role="alert">
      {{ alert.message }}
      <button
        @click="alertStore.clear()"
        type="button"
        class="btn-close"
        data-bs-dismiss="alert"
        aria-label="Close"
      ></button>
    </div>
  </div>
</template>
